/**
 * Query key fabrikası.
 *
 * Anahtarlar elle yazıldığında `['schedule', …]` ile `['schedules', …]` arasındaki
 * fark derleme zamanında görünmez ve invalidation sessizce çalışmaz — en zor
 * bulunan cache hatası budur. Tek kaynaktan üretmek bunu imkânsız kılar.
 */
export const qk = {
  me: () => ['me'] as const,
  /* `me` önekinin DIŞINDA: sözleşme imzalanınca `me` elle yazılır, bu tazelenir. */
  myAgreement: () => ['agreement', 'mine'] as const,

  instructors: () => ['instructors'] as const,
  /* Eğitmenin kendi profili (Profilim) — `instructors` önekinde: eğitmen
     listesi tazelenince bu da tazelenir. */
  myInstructor: () => ['instructors', 'me'] as const,

  /* Program omurgası. `enrollment(id)` bilerek `enrollments` ile aynı önekten
     başlıyor: bir kayıt değiştiğinde `qk.enrollments()` invalidate etmek hem
     listeyi hem detayları tazeler. */
  programCatalog: () => ['program-catalog'] as const,
  students: () => ['students'] as const,
  enrollments: () => ['enrollments'] as const,
  enrollmentList: (filters: Record<string, unknown>) => ['enrollments', 'list', filters] as const,
  enrollment: (id: string) => ['enrollments', id] as const,

  /* Ders Programı — tek takvim. Önek `['schedule']`: bir kayıt, ders ya da
     mazeret değişince önek invalidate edilir (personel ve üye birlikte). */
  scheduleAll: () => ['schedule'] as const,
  schedule: (filters: Record<string, unknown>) => ['schedule', 'staff', filters] as const,
  myLessons: (from: string, to: string) => ['schedule', 'mine', from, to] as const,
  myPackages: () => ['schedule', 'my-packages'] as const,
  /* Yönetici önizlemesi — yine `schedule` önekinde, mutasyonlarla tazelenir. */
  memberLessons: (memberId: string, from: string, to: string) =>
    ['schedule', 'member', memberId, from, to] as const,
  memberPackages: (memberId: string) => ['schedule', 'member-packages', memberId] as const,

  /* Tanıtım sitesi anahtarları ayrı: aynı veri DEĞİL (public uç operasyonel
     alanları taşımıyor) ve aynı anahtarı paylaşmak, panelde yapılan bir
     invalidate'in siteyi de tazelemesine — ya da tersine yanlış veriyi
     göstermesine — yol açardı. */
  publicPrograms: () => ['public', 'programs'] as const,
  publicProgram: (slug: string) => ['public', 'programs', slug] as const,
  faqs: () => ['public', 'faqs'] as const,
  testimonials: () => ['public', 'testimonials'] as const,
  studio: () => ['public', 'studio'] as const,
  /* Galeri iki ayrı anahtar taşıyor ve bu bilinçli: `media` yöneticinin
     gördüğü TAM kütüphane (galeride olmayanlar dahil, künye alanlarıyla),
     `gallery` ise sitenin gördüğü yayınlanmış liste. Tek anahtar paylaşsalardı
     yönetim ekranındaki bir tazeleme, ziyaretçinin görmemesi gereken taslak
     görselleri de cache'e sokardı. */
  media: (inGallery = false) => ['media', { inGallery }] as const,
  gallery: () => ['public', 'gallery'] as const,
  rooms: (includeInactive = false) => ['rooms', { includeInactive }] as const,
  roomUtilization: (from: string, to: string) => ['rooms', 'utilization', from, to] as const,

  /* Yönetim listeleri, herkese açık karşılıklarından AYRI anahtarda.
     Aynı tablolar ama aynı veri DEĞİL: yönetim gövdesi pasif satırları,
     satış sayısını ve yayınlanmamış yorumları taşıyor. Anahtarı
     paylaşsalardı panelde yapılan bir tazeleme, ziyaretçinin görmemesi
     gereken taslak yorumları cache'e sokardı — galeri için `media`/`gallery`
     ayrımının aynısı. */
  /* Eğitimler & Paketler — fiyatlı, pasifler dahil. Değişince kayıt formunun
     kataloğu (`programCatalog`) ve tanıtım sitesi (`publicPrograms`) de tazelenir. */
  adminPrograms: () => ['admin', 'programs'] as const,
  adminTestimonials: () => ['admin', 'testimonials'] as const,
  adminFaqs: () => ['admin', 'faqs'] as const,
  adminInstructorReviews: () => ['admin', 'instructor-reviews'] as const,
  adminMembers: (filters: Record<string, unknown>) => ['admin', 'members', filters] as const,
  /* Eğitmen yönetimi `['admin','instructors']` önekinin altında: yetki
     değişince hem profil listesi hem "profil açılabilecek hesaplar" değişir
     ve tek invalidate ikisini birden tazeler. */
  adminInstructors: () => ['admin', 'instructors', 'list'] as const,
  assignableInstructorAccounts: () => ['admin', 'instructors', 'assignable'] as const,

  stats: () => ['reports', 'stats'] as const,
} as const;
